module.exports = __webpack_public_path__ + "img/handraw_additionnel.39e8667b.svg";